import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isDirty, isValid, reset, change, getFormSyncErrors } from 'redux-form';
import { actions as documentOutputActions, selectors as documentOutputSelectors } from 'ducks/documentOutput';
import ReceiptConfirmation from './ProcessCreditNoteDialog';
import { IApplicationState } from 'ducks/reducers';
import { selectors as staffSelectors } from 'ducks/staff';

const FORM_NAME = 'ReceiptConfirmationForm';
const mapStateToProps = (state: IApplicationState) => ({
  printCreditNoteDocumentOutputOptions: documentOutputSelectors.options('CN', 'CreditNoteOutput')(state),
  printDocketDocumentOutputOptions: documentOutputSelectors.options('CN', 'DocketOutput')(state),
  dirty: isDirty(FORM_NAME)(state),
  values: getFormValues(FORM_NAME)(state),
  isValid: isValid(FORM_NAME)(state),
  currentUserId: staffSelectors.id(state) ? staffSelectors.id(state) : '',
  formSyncErrors: getFormSyncErrors(FORM_NAME)(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset(FORM_NAME),
    setPrintCreditNoteDocumentOutputOptions: (options) => documentOutputActions.updateInitialOptions('CN', 'CreditNoteOutput', options),
    clearPrintCreditNoteDocumentOutputOptions: () => documentOutputActions.clearInitialOptions('CN', 'CreditNoteOutput'),
    setPrintDocketDocumentOutputOptions: (options) => documentOutputActions.updateInitialOptions('CN', 'DocketOutput', options),
    clearPrintDocketDocumentOutputOptions: () => documentOutputActions.clearInitialOptions('CN', 'DocketOutput'),
    changeFormFieldValue: (fieldName: string, fieldValue: any) => change(FORM_NAME, fieldName, fieldValue),
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReceiptConfirmation);
